import { ColumnDetails, GetRowsRequest, GetSummaryResponse, SetFiltersRequest } from '../../../../grid/types/common';
import { Column, ColumnKeys, Dependencies, DeployerRelaysEndpointMethod } from '../types';
import { ConsoleRequest, DataProviderType } from '../../../../utils/request';
import { GridBaseDataProvider } from '../../../../grid/GridBaseDataProvider';
import { DeployerGridResponses } from '../types/deployer-grid-responses';
import { DeployerGridWebComponent } from '../component/DeployerGridWebComponent';

export class DeployerGridGzDataProvider extends GridBaseDataProvider<Column, ColumnKeys> {
  private cachedGetDeployerRelaysResponse?: DeployerGridResponses;
  private readonly allColumnDetails: {};

  constructor(public dependencies: Dependencies, allColumnDetails: ColumnDetails<Column, ColumnKeys>[]) {
    super();
    this.allColumnDetails = allColumnDetails.reduce((acc, curr) => ({ ...acc, [curr.key]: curr }), {});
  }

  private async getDeployerRelays(request: GetRowsRequest<Column, ColumnKeys>): Promise<DeployerGridResponses> {
    const payload = ConsoleRequest.mapGridRequestToPayload(request, this.dependencies.getTimezone());
    return (await ConsoleRequest.createRequest<any>({
      dataProviderType: DataProviderType.CORE,
      payload: {
        companyId: DeployerGridWebComponent.companyId,
        ...payload,
      },
      endpoint: 'ProtectedEntities',
      method: DeployerRelaysEndpointMethod.GET_SUPER_AGENTS,
    })) as DeployerGridResponses;
  }

  async getSummary(request: GetRowsRequest<Column, ColumnKeys>): Promise<GetSummaryResponse> {
    this.cachedGetDeployerRelaysResponse = await this.getDeployerRelays(request);

    return {
      summary: '',
      numItems: this.cachedGetDeployerRelaysResponse.total,
    };
  }

  async getRows(request: GetRowsRequest<Column, ColumnKeys>) {
    if (!this.cachedGetDeployerRelaysResponse) {
      this.cachedGetDeployerRelaysResponse = await this.getDeployerRelays(request);
    }

    return {
      success: true,
      rawEvents: this.cachedGetDeployerRelaysResponse.data,
    };
  }

  async setFilters(request: SetFiltersRequest<ColumnKeys>): Promise<{} | undefined> {
    return;
  }
}
